import React from 'react';
import { Button } from 'carbon-components-react';
import { ReactComponent as UserServiceDeskIcon } from 'assets/icons/user--service-desk.svg';

const ReferralDetails = ({
  referral,
  status,
  onClickReferralContactButton
}: {
  referral: any;
  status: string;
  onClickReferralContactButton: () => void;
}) => {
  const noContactAvailable =
    !referral.contactPhoneNumber &&
    !referral.contactEmail &&
    !referral.contactUrl &&
    !referral.contactEmergencyPhone;

  return (
    <div className="mobile-view-referral-details-container">
      <div className="mobile-view-referral-details-content">
        <div className="mobile-view-referral-logo-container">
          {referral.logo ? (
            <img
              src={`${process.env.REACT_APP_RSOTF_API_URL}/community/organisations/${referral.organisationId}/logo`}
              alt="Logo"
              className="mobile-view-referral-logo"
              title={referral.name}
              onError={(e) => {
                e.currentTarget.style.display = 'none';
                const sibling = e.currentTarget.nextElementSibling;
                if (sibling instanceof HTMLElement) {
                  sibling.style.display = 'flex';
                }
              }}
            />
          ) : null}
          <div
            className={`mobile-view-referral-name ${
              referral.logo ? 'mobile-view-referral-name-hidden' : ''
            }`}
          >
            {referral.name}
          </div>
        </div>
        <div className="mobile-view-referral-id">
          <span className="mobile-view-referral-id-label">Referral ID:</span>{' '}
          {referral.externalId}
        </div>
      </div>
      <div>
        <Button
          kind="ghost"
          className="mobile-view-referral-contact-button"
          onClick={onClickReferralContactButton}
          disabled={status === 'EXPIRED' || noContactAvailable}
        >
          <UserServiceDeskIcon
            className="mobile-view-contact-icon"
            fill="currentColor"
          />
        </Button>
      </div>
    </div>
  );
};

export default ReferralDetails;
